export const PlusIcon = () => (
  <div className="relative w-4 h-4 flex items-center justify-center">
    <div className="plus-icon"></div>
    <div className="plus-icon rotate-90 absolute"></div>
  </div>
);
